{
  "title": "資格驗證資料頁欄位參考",
  "description": "「資格驗證資料」頁的欄位定義與可用篩選條件；本頁不提供通過／退回操作，實際審核請至資格驗證審核工作台。",
  "headings": ["欄位說明", "可用篩選條件"],
  "intro": "「資料」分組下的「資格驗證資料」頁是資格驗證審核工作台的唯讀延伸，兩者資料來源完全相同，並非另一套資料。本頁額外呈現每位成員的證明版本歷程，以及是否已依保存政策清除檔案；但本頁不提供「通過」或「退回」操作，實際審核仍須至「隊伍與人員」的資格驗證審核分頁進行。",
  "submissionSectionHeading": "欄位說明",
  "submissionStatuses": [
    { "name": "成員", "editable": "成員顯示名稱與 Email。" },
    { "name": "隊伍", "editable": "所屬隊伍名稱；未加入隊伍時顯示為空白符號。" },
    { "name": "學校", "editable": "成員填寫的學校名稱；未填寫時顯示「未設定」。" },
    { "name": "證明類型", "editable": "目前生效證明的類型；尚未上傳任何證明時顯示「無證明」。" },
    { "name": "狀態", "editable": "資格驗證狀態徽章，與資格驗證審核工作台完全相同的狀態定義。" },
    {
      "name": "目前版本",
      "editable": "目前生效證明的上傳時間；若該檔案已依保存政策清除，顯示「已清除檔案」徽章而非時間。"
    },
    { "name": "最後更新時間", "editable": "該筆資格驗證紀錄最後一次異動的時間。" },
    {
      "name": "審核人",
      "editable": "最後一次審核該筆資格的使用者 ID；尚未審核過則顯示為空白符號。"
    },
    {
      "name": "操作",
      "editable": "「版本歷程」按鈕可展開查看完整的證明上傳歷史（唯讀）；狀態為「待審核」時，另會顯示「前往審核」連結，導向資格驗證審核工作台並帶入該隊伍篩選條件，實際核准或退回動作在該工作台完成。"
    }
  ],
  "judgeSectionHeading": "可用篩選條件",
  "judgeStatuses": [
    { "name": "依狀態篩選", "description": "只顯示指定資格驗證狀態的成員。" },
    { "name": "依隊伍 ID 篩選", "description": "輸入隊伍 ID 文字進行篩選。" },
    {
      "name": "文字搜尋",
      "description": "依成員或學校相關文字搜尋，篩選條件皆會保留在網址列，方便分享或重新整理後仍維持原本的查詢結果。"
    }
  ]
}
